import { Link } from 'react-router-dom';
import { cn, ImageUtils, PaletteUtils, RoutePaths } from '@shared/utils';
import type { LifestyleCategory } from '@shared/api';
import { Text } from '@shared/widgets';

interface CategoryCardProps {
  className?: string;
  category: LifestyleCategory;
}

export const CategoryCard = (props: CategoryCardProps) => {
  return (
    <Link
      className={cn(
        'group relative block h-52 overflow-hidden',
        PaletteUtils.isInsigniaPalette && 'rounded-sm',
        PaletteUtils.isVcfcPalette && 'rounded-xl',
        props.className,
      )}
      to={RoutePaths.conciergeRequest.onNavigate(props.category.type)}
    >
      <img
        className={cn('absolute inset-0 h-full w-full object-cover transition-transform duration-300', 'group-hover:scale-105')}
        src={ImageUtils.getCloudinaryImage(props.category.image)}
        alt={props.category.title}
      />
      <div className='absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-black/10' />
      <div className='relative z-10 flex h-full flex-col justify-end gap-1 p-5'>
        <Text tag='h3' weight='semibold' size='lg' color='white'>
          {props.category.title}
        </Text>
        <Text tag='p' size='sm' color='white'>
          {props.category.description}
        </Text>
      </div>
    </Link>
  );
};
